import { render, staticRenderFns } from "./DeleteRecruitmentTypeConfirmation.vue?vue&type=template&id=2f21e6e5"
import script from "./DeleteRecruitmentTypeConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteRecruitmentTypeConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports